import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { UserData } from 'src/app/Services/data.model';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  constructor(private http: HttpClient, private service: ApiService) { }

  // browserDomain : string = this.service.browserDomain;    //Local
  browserDomain : string = this.service.browserDomain;    //Test
  // domain : string = "http://52.66.61.183";

  LoginURL(){
   const loginUrl = this.service.LoginURL();
   return loginUrl;
  }
  studentLoginURL(){
    const loginUrl = this.service.studentLoginURL();
    return loginUrl;
   }
  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'auth')
    return FinalURL; 
  }

  login(authData){
    return this.http.post<any>(this.LoginURL(), authData);
  }
  studentLogin(authData){
    return this.http.post<any>(this.studentLoginURL(), authData);
  }
  sendOtp(mobile): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendLogin/otp?mobile='+mobile))
  }
  resendOtp(mobile,value): Observable<UserData>{
    let querParam = mobile;
    if(value=='call')
    {
      querParam+='&retryType=Default';
    }
    return this.http.get<UserData>(this.URLAddress('/resend/otp?mobile='+querParam))
  }
  verifyOtp(mobile, otp, source): Observable<any>{
    return this.http.get<any>(this.URLAddress('/verify/otp?mobile='+mobile+'&otp='+otp+ '&source='+source))
  }
  changePasswd(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/changePassword/otp')),formData)
  }
  loggedIn() {
    return !!localStorage.getItem('token')    
  }
  openEntityList(): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/openEntityList'))
  }
  getEntityByQac(qac): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/getEntityByQAC?qac='+qac))
  }
}
